import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "themeButton-textWrapper"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
import ThemeIcon from '../Icon/Icon.vue';
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        title: {},
        wcaTitle: {},
        type: {},
        tagname: {},
        subtitle: {},
        icon: {},
        iconAfter: {},
        size: {},
        fill: {},
        variation: {},
        color: {},
        state: {}
    },
    setup(__props) {
        const props = __props;
        const type = props.type || 'button';
        const tagname = props.tagname || (props.type === 'link' ? 'a' : 'button');
        const classes = computed(() => {
            return {
                [`size--${props.size || 'normal'}`]: true,
                [`fill--${props.fill || 'solid'}`]: true,
                [`accentColor--${props.color}`]: props.color,
                [`var--${props.variation}`]: props.variation,
                [`is--${props.state}`]: props.state,
                'only--icon': !props.title && (props.icon || props.iconAfter),
                'only--title': props.title && !(props.icon || props.iconAfter),
                'icon--before': props.title && props.icon,
                'icon--after': props.title && props.iconAfter,
            };
        });
        const wcaTitle = computed(() => {
            return props.wcaTitle || props.title || '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(tagname)), {
                class: _normalizeClass(["themeButton", classes.value]),
                title: wcaTitle.value,
                "aria-label": wcaTitle.value,
                type: _unref(type) === 'link' ? '' : _unref(type)
            }, {
                default: _withCtx(() => [
                    (_ctx.icon)
                        ? (_openBlock(), _createBlock(ThemeIcon, {
                            key: 0,
                            name: _ctx.icon,
                            class: "themeButton-icon"
                        }, null, 8, ["name"]))
                        : _createCommentVNode("", true),
                    (_ctx.title || _ctx.subtitle)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                            (_ctx.title)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "themeButton-title",
                                    innerHTML: _ctx.title
                                }, null, 8, _hoisted_2))
                                : _createCommentVNode("", true),
                            (_ctx.subtitle)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "themeButton-subtitle",
                                    innerHTML: _ctx.subtitle
                                }, null, 8, _hoisted_3))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.iconAfter)
                        ? (_openBlock(), _createBlock(ThemeIcon, {
                            key: 2,
                            name: _ctx.iconAfter,
                            class: "themeButton-icon"
                        }, null, 8, ["name"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["class", "title", "aria-label", "type"]));
        };
    }
});
